// extracted by mini-css-extract-plugin
export default {"unavailable-icon":"GamePowerscore_unavailable-icon__mthQ7"};